var map = {
	"./placemark.svg": 295
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 294;


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/samap/img/placemarks nonrecursive \.svg
// module id = 294
// module chunks = 0 2